/*
 * File: /src/mixins/currency.js
 * Created Date: Saturday September 25th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Saturday, 25th September 2021 1:58:22 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */
export default {
  methods: {
    toCurrency(
      priceInput,
      isInt = false,
      minimumFractionDigits = 2,
      maximumFractionDigits = 2
    ) {
      let price = priceInput;
      // Explicit nulls are allowed to be skipped
      if (isNaN(price) || price === null) {
        // Return raw if not valid;
        return price;
      }
      if (isInt) {
        price = priceInput / 100;
      }
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: minimumFractionDigits,
        maximumFractionDigits: maximumFractionDigits
      }).format(price);
    }
  }
};
